import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n";

const Navbar = () => {
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuOpen &&
        navbarRef.current &&
        !navbarRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);
  
  const handleLinkClick = (e, hash) => {
    handleNavClick(e, hash);
    setMenuOpen(false);
  };

  const handleToggle = () => {
    setLanguage(language === "en" ? "es" : "en");
  };

  const handleNavClick = (e, hash) => {
      e.preventDefault();
      navigate("/");
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    
  };

  return (
    <div className="navbar-container" ref={navbarRef}>
      <div className="navbar-logo-container">
        <Link to="/#root" onClick={(e) => handleNavClick(e, "#root")}>
          {"i<am>"}
        </Link>
      </div>
      <div
        className={`navbar-menu-toggle ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span />
        <span />
        <span />
      </div>
      <div className={`navbar-links-container ${menuOpen ? "open" : ""}`}>
        <Link
          to="/#about-container"
          onClick={(e) => handleLinkClick(e, "#about-container")}
        >
          {translations[language].sectionTitles.about}
        </Link>
        <Link
          to="/#experience-container"
          onClick={(e) => handleLinkClick(e, "#experience-container")}
        >
          {translations[language].sectionTitles.experience}
        </Link>
        <Link
          to="/#knowledge-container"
          onClick={(e) => handleLinkClick(e, "#knowledge-container")}
        >
          {translations[language].sectionTitles.knowledge}
        </Link>
        <Link
          to="/#contact-container"
          onClick={(e) => handleLinkClick(e, "#contact-container")}
        >
          {translations[language].sectionTitles.contact}
        </Link>
        <div className="navbar-language-toggle" onClick={handleToggle}>
          <div
            style={{
              color: language === "es" ? "#00D6C3" : "#0D7377",
            }}
          >
            ES
          </div>
          <div className="navbar-language-selector">
            <div
              className="navbar-language-dot"
              style={{
                left: language === "en" ? "25px" : "5px",
                transition: "left 0.3s",
              }}
            ></div>
          </div>
          <div
            style={{
              color: language === "en" ? "#00D6C3" : "#0D7377",
            }}
          >
            EN
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
